import { useEffect, useState } from 'react';
import { useSearchCriteria } from '@/states';

/**
 * Hook to manage search form state and sync with SearchCriteriaContext
 * @param {string} serviceType - 'hotels', 'excursions', or 'carRental'
 */
export const useSearchForm = (serviceType) => {
  const { updateCriteria, criteria } = useSearchCriteria();
  const [formData, setFormData] = useState(criteria[serviceType] || {});

  // Update context when form data changes
  useEffect(() => {
    // Only update if there's meaningful data
    const hasData = Object.keys(formData).some(key => {
      const value = formData[key];
      return value !== null && value !== undefined && value !== '' && value !== -1;
    });

    if (hasData) {
      updateCriteria(serviceType, formData);
    }
  }, [formData, serviceType, updateCriteria]);

  const updateField = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const updateMultipleFields = (fields) => {
    setFormData(prev => ({
      ...prev,
      ...fields
    }));
  };

  const resetForm = () => {
    setFormData({});
  };

  return {
    formData,
    updateField,
    updateMultipleFields,
    resetForm,
    setFormData
  };
};
